/**
 * Quiz is Session Runtime — keep Exam Space open; open attempts in a new browser tab.
 */

export function isQuizRuntimeHref(href: string | null | undefined): boolean {
  if (!href) return false;
  try {
    if (href.startsWith('/quiz')) return true;
    if (href.startsWith('http://') || href.startsWith('https://')) {
      const url = new URL(href);
      return url.pathname === '/quiz' || url.pathname.startsWith('/quiz/');
    }
    return false;
  } catch {
    return href.startsWith('/quiz');
  }
}

/** Open /quiz Attempt in a new tab. Non-quiz hrefs fall back to same-tab assign. */
export function openQuizRuntimeHref(href: string): void {
  if (!isQuizRuntimeHref(href)) {
    window.location.assign(href);
    return;
  }

  const opened = window.open(href, '_blank', 'noopener,noreferrer');
  if (opened) {
    opened.opener = null;
  }
}
